import type { IWatermarkSet, CreateWatermarkSet } from '../types/watermarks.types';
import { Delete, Get, Patch, Post } from './helpers';

const watermarkPath = (channel: number) => `/v4/admin/watermarks/${channel}`;

export function GetWatermarksByChannel(channel: number, token: string): Promise<IWatermarkSet[]> {
	return Get(watermarkPath(channel), token);
}

export function GetWatermark(channel: number, uuid: string, token: string): Promise<IWatermarkSet> {
	return Get(watermarkPath(channel) + `/${uuid}`, token);
}

export function CreateWatermark(watermark: CreateWatermarkSet, token: string): Promise<IWatermarkSet> {
	return Post(watermarkPath(watermark.channel), token, { ...watermark });
}

export function UpdateWatermark(watermark: IWatermarkSet, token: string): Promise<IWatermarkSet> {
	return Patch(watermarkPath(watermark.channel) + `/${watermark.uuid}`, token, { ...watermark }, true);
}

export async function DeleteWatermark(channel: number, uuid: string, token: string): Promise<void> {
	const ok = await Delete(watermarkPath(channel) + `/${uuid}`, token);
	if (!ok) throw new Error('Failed to delete watermark');
}
